import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import FileUploader from '../components/FileUploader';
import DocumentList from '../components/DocumentList';
import OllamaStatusBadge from "../components/OllamaStatusBadge";

import { Container, Row, Col } from 'react-bootstrap';

function AdminDashboard() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="d-flex">
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />

      <Container
        fluid
        className="pt-4"
        style={{
          marginLeft: sidebarCollapsed ? '60px' : '220px',
          transition: 'margin-left 0.3s ease'
        }}
      >
        <Row>
          <OllamaStatusBadge />
          <Col md={6}>
            <FileUploader />
          </Col>
          <Col md={6}>
            <DocumentList />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AdminDashboard;
